export default {
  name: 'NotFound',
};
